import useStorage, {StorageData} from "../hooks/useStorage"
import {HomeNavigation} from "../types/HomeNavigation"

const useHomeNavigation = () => {
  const storage = useStorage("session", StorageData.homeNavigation)

  const addItemIfNotExists = (nav: HomeNavigation, item: string): boolean => {
    if (
      nav?.historyNavigation.length > 0 &&
      item === nav.historyNavigation[nav.historyNavigation.length - 1]
    ) {
      return false
    }
    return true
  }

  const getNavigationObject = (): HomeNavigation => {
    let navJson = storage.get() || undefined
    return navJson ? JSON.parse(navJson) : {historyNavigation: []}
  }

  const getNavigationPrev = (): string => {
    let nav = getNavigationObject()
    if (nav && nav.historyNavigation.length > 0) {
      let index =
        nav.historyNavigation.length > 1
          ? nav.historyNavigation.length - 1 - 1
          : nav.historyNavigation.length - 1
      return nav.historyNavigation[index]
    }
    return "Overview"
  }

  const createNavigationHistory = async () => {
    storage.set(JSON.stringify({historyNavigation: []}))
  }

  const addNavigationHistory = async (item: string) => {
    let nav = getNavigationObject()
    if (addItemIfNotExists(nav, item)) {
      nav.historyNavigation.push(item)
      storage.set(JSON.stringify(nav))
    }
  }

  const removeNavigationHistory = async () => {
    let nav = getNavigationObject()
    if (nav && nav.historyNavigation.length > 0) {
      nav.historyNavigation.splice(nav.historyNavigation.length - 1)
      storage.set(JSON.stringify(nav))
    }
  }

  const clearNavigationHistory = async () => {
    storage.get() && storage.clear()
  }

  return {
    createNavigationHistory,
    addNavigationHistory,
    getNavigationPrev,
    removeNavigationHistory,
    clearNavigationHistory,
    getNavigationObject,
  }
}

export default useHomeNavigation
